import { clusterGpsFlags, formatDuration } from "./gps-windows.js";
import dayjs from "dayjs";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/shift-flags/ShiftGpsWindows.tsx
var MAX_WINDOWS = 12;
function ShiftGpsWindows({ flags }) {
	const windows = clusterGpsFlags(flags ?? []);
	if (windows.length === 0) return null;
	const totalDurationMs = windows.reduce((sum, w) => sum + w.durationMs, 0);
	const headerCount = `${windows.length} window${windows.length === 1 ? "" : "s"}`;
	return /* @__PURE__ */ jsxs("div", {
		className: "text-muted text-xs",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "font-medium",
				children: totalDurationMs > 0 ? `GPS out of bounds — ${headerCount} · ${formatDuration(totalDurationMs)} total` : `GPS out of bounds — ${headerCount}`
			}),
			windows.slice(0, MAX_WINDOWS).map((window, index) => /* @__PURE__ */ jsx("div", { children: window.readingCount === 1 ? `${dayjs(window.start).format("h:mm a")} · 1 reading` : `${dayjs(window.start).format("h:mm a")} – ${dayjs(window.end).format("h:mm a")} · ${formatDuration(window.durationMs)} · ${window.readingCount} gps tags` }, `${window.start}-${index}`)),
			windows.length > MAX_WINDOWS && /* @__PURE__ */ jsx("div", { children: `+${windows.length - MAX_WINDOWS} more` })
		]
	});
}
//#endregion
export { ShiftGpsWindows };

//# sourceMappingURL=ShiftGpsWindows.js.map